import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.ImageBinary.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.ImageBinary.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.question = null;
  this.answers = [];
};

EDC.Games.ImageBinary.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.ImageBinary.Scenes.Main.prototype.constructor = EDC.Games.ImageBinary.Scenes.Main;

const IB = EDC.Games.ImageBinary.Scenes.Main.prototype;

IB.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

IB.loadIteration = function () {
  this.createQuestion();
  this.createAnswers();
};

IB.createAnswers = function () {
  const { answer1 } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { answer2 } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { solution } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];

  const container1 = this.add.container(330, 540);
  const frame1 = this.add.sprite(0, 0, 'frame');
  const sprite1 = this.add.sprite(0, 0, `answer-${answer1}`);
  container1.add(frame1);
  container1.add(sprite1);
  container1.setSize(450, 400);
  container1.setInteractive();
  this.scaleAnimation(container1);
  const markAnim1 = new AnswerMark(this, container1).setScale(0.8);
  container1.setData('markAnim', markAnim1);
  this.cursorManager.setDefaultDraggableEvents(container1);
  container1.on('pointerup', this.checkAnswer.bind(this, container1), this);

  const container2 = this.add.container(1580, 540);
  const frame2 = this.add.sprite(0, 0, 'frame');
  const sprite2 = this.add.sprite(0, 0, `answer-${answer2}`);
  container2.add(frame2);
  container2.add(sprite2);
  container2.setSize(450, 400);
  container2.setInteractive();
  this.scaleAnimation(container2);
  const markAnim2 = new AnswerMark(this, container2).setScale(0.8);
  container2.setData('markAnim', markAnim2);
  this.cursorManager.setDefaultDraggableEvents(container2);
  container2.on('pointerup', this.checkAnswer.bind(this, container2), this);

  if (solution === 1) {
    container1.isCorrect = true;
    container2.isCorrect = false;
  } else {
    container1.isCorrect = false;
    container2.isCorrect = true;
  }
  this.answers.push(container1);
  this.answers.push(container2);
};

IB.checkAnswer = function (answer) {
  answer.disableInteractive();
  answer.getData('markAnim').showMark(answer.isCorrect, () => {});
  answer.scaleAnim.stop();
  answer.setScale(1);
  this.tweens.add({
    targets: answer,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 75,
    ease: 'Linear',
    yoyo: true,
  });
  if (answer.isCorrect) {
    this.playCorrect();
    this.answers.map((x) => {
      x.disableInteractive();
      x.scaleAnim.stop();
      x.setScale(1);
      return true;
    });
    this.question.shakeAnim.stop();
    this.question.angle = 0;
    this.time.delayedCall(2000, this.shrinkAnimation, [], this);
  } else {
    this.playWrong();
  }
};

IB.shrinkAnimation = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.answers.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.3',
        scaleY: '+=0.3',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      return true;
    });
    this.tweens.add({
      targets: this.question,
      scaleX: '+=0.3',
      scaleY: '+=0.3',
      duration: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    this.tweens.add({
      targets: this.question,
      scaleX: 0,
      scaleY: 0,
      duration: 500,
      delay: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

IB.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
    return true;
  });
  this.answers = [];
  this.question.destroy();
  this.question = null;
  this.loadIteration();
};

IB.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Linear',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 9000),
  });
};

IB.createQuestion = function () {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let item;
  const isImage = this.gameConfig.assets.questions[question].img;
  const font = {
    font: `600px ${this.gameConfig.font}`,
  };
  if (isImage) {
    item = this.add.sprite(this.game.config.width / 2, 755, `question-${question}`).setOrigin(0.5, 1);
  } else {
    item = this.add
      .text(this.game.config.width / 2, 600, this.gameConfig.assets.questions[question].text, font)
      .setOrigin(0.5, 0.5);
  }
  this.shakeAnimation(item);
  this.question = item;
};

IB.shakeAnimation = function (container) {
  container.shakeAnim = this.tweens.add({
    targets: container,
    angle: 6,
    duration: 75,
    ease: 'Linear',
    delay: 6500,
    repeat: 4,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, container),
  });
};

IB.createTemplateUI = function () {
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(this.game.config.width / 2, 30, 'title').setOrigin(0.5, 0);
  } else {
    title = this.make.text({
      x: this.game.config.width / 2,
      y: 30,
      text: this.gameConfig.titleTxt,
      origin: { x: 0.5, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '950' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(this.game.config.width / 2, 870, 'instructions').setOrigin(0.5, 0);
  } else {
    instructions = this.make.text({
      x: this.game.config.width / 2,
      y: 920,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  const grid = this.add.sprite(this.game.config.width / 2, 530, 'grid');
};

export default EDC.Games.ImageBinary.Scenes.Main;
